// CLASSES
import ProductPurchase from "./ProductPurchase";

export default function (props, state) {

	if (state.fields.customer_product_deposit_checkbox.checked) {
		if (state.fields.investedamount < ProductPurchase.minimumAmountSingleDeposit) {
			return false;
		}
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/ProductPurchase/alfakraft/ProductPurchase.fulfillment.js